/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';

import PanelLayout from '../layouts/PanelLayout.vue';
import PublicLayout from '../layouts/PublicLayout.vue';
import EditLayout from '../layouts/EditLayout.vue';
import CheckoutLayout from '../layouts/CheckoutLayout.vue';

import checkAuthenticatedUser from '../middleware/checkAuthenticatedUser';
import checkAuthenticationPage from '../middleware/checkAuthenticationPage';
import enableFreePass from '../middleware/enableFreePass';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: PanelLayout,
    children: [
      {
        path: '',
        name: 'Panel',
        component: () => import(/* webpackChunkName: "panel" */'../views/panel/Main.vue'),
        meta: {
          title: 'Mis cursos',
          middleware: [checkAuthenticatedUser],
        },
      },
      {
        path: 'membresia',
        name: 'Membership',
        component: () => import(/* webpackChunkName: "membership" */'../views/panel/Membership.vue'),
        meta: {
          title: 'Membresias',
          middleware: [checkAuthenticatedUser],
        },
      },

      {
        path: 'ingresos',
        name: 'Earnings',
        component: () => import(/* webpackChunkName: "earnings" */'../views/panel/Earnings.vue'),
        meta: {
          title: 'Mis ingresos',
          middleware: [checkAuthenticatedUser],
        },
      },
      {
        path: 'ingresos/:teacher_id',
        name: 'Earnings',
        component: () => import(/* webpackChunkName: "earnings" */'../views/panel/Earnings.vue'),
        meta: {
          title: 'Mis ingresos',
          middleware: [checkAuthenticatedUser],
        },
      },

      {
        path: 'especialidad/:speciality_id',
        name: 'Speciality',
        component: () => import(/* webpackChunkName: "speciality" */ '../views/Speciality.vue'),
        meta: {
          middleware: [checkAuthenticatedUser],
        },
      },
    ]
  },
  {
    path: '/editar',
    component: EditLayout,
    children: [
      {
        path: '',
        name: 'Edit',
        component: () => import(/* webpackChunkName: "edit" */'../views/edit/Main.vue'),
        meta: {
          title: 'Editar',
          middleware: [checkAuthenticatedUser],
        },
      },
      {
        path: 'password',
        name: 'Edit Password',
        component: () => import(/* webpackChunkName: "edit-password" */'../views/edit/Password.vue'),
        meta: {
          title: 'Editar contraseña',
          middleware: [checkAuthenticatedUser],
        },
      },
      {
        path: 'conecta',
        name: 'Edit Connecta',
        component: () => import(/* webpackChunkName: "edit-connecta" */'../views/edit/Connecta.vue'),
        meta: {
          title: 'Editar perfil conecta',
          middleware: [checkAuthenticatedUser],
        },
      },
    ]
  },
  {
    path: '/curso/:course_id/lecciones/:module/:lection_slug',
    name: 'Lection',
    component: () => import(/* webpackChunkName: "lection" */ '../views/Lection.vue'),
    meta: {
      middleware: [enableFreePass],
    },
  },
  {
    path: '/curso/:speciality_id/:course_id/lecciones/:module/:lection_slug',
    name: 'Speciality Lection',
    component: () => import(/* webpackChunkName: "lection" */ '../views/Lection.vue'),
    meta: {
      middleware: [enableFreePass],
    },
  },
  {
    path: '/curso/:course_id/examen/:exam_id',
    name: 'Exam',
    component: () => import(/* webpackChunkName: "exam" */ '../views/Exam.vue'),
    meta: {
      middleware: [checkAuthenticatedUser],
    },
  },
  {
    path: '/curso/:speciality_id/:course_id/examen/:exam_id',
    name: 'Speciality Exam',
    component: () => import(/* webpackChunkName: "exam" */ '../views/Exam.vue'),
    meta: {
      middleware: [checkAuthenticatedUser],
    },
  },
  {
    path: '/checkout',
    component: CheckoutLayout,
    children: [
      {
        path: 'payment',
        name: 'Checkout Payment',
        component: () => import(/* webpackChunkName: "checkout-payment" */ '../views/checkout/Payment.vue'),
        meta: {
          middleware: [enableFreePass],
        },
      },
      {
        path: 'v2/payment',
        name: 'Checkout Payment V2',
        component: () => import(/* webpackChunkName: "checkout-payment-v2" */ '../views/checkout/PaymentV2.vue'),
        meta: {
          middleware: [enableFreePass],
        },
      },
      {
        path: 'order-received/:order_id',
        name: 'Checkout Order',
        component: () => import(/* webpackChunkName: "checkout-order" */ '../views/checkout/OrderReceived.vue'),
        meta: {
          middleware: [enableFreePass],
        },
      },
      {
        path: 'membership/order-received/:order_id',
        name: 'Checkout Order',
        component: () => import(/* webpackChunkName: "checkout-order" */ '../views/checkout/OrderReceived.vue'),
        meta: {
          middleware: [enableFreePass],
        },
      },
    ],
  },
  {
    path: '/',
    component: PublicLayout,
    children: [
      {
        path: 'ingresar',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login-register" */ '../views/auth/Main.vue'),
        meta: {
          title: 'Ingresar',
          middleware: [checkAuthenticationPage],
        },
      },
      {
        path: 'registrarse',
        name: 'Register',
        component: () => import(/* webpackChunkName: "login-register" */ '../views/auth/Main.vue'),
        meta: {
          title: 'Registrarse',
          middleware: [checkAuthenticationPage],
        },
      },
      {
        path: 'olvidaste-contrasena',
        name: 'Recovery Send',
        component: () => import(/* webpackChunkName: "recovery-send" */ '../views/auth/recovery/Send.vue'),
        meta: {
          title: '¿Olvidaste tu contraseña?',
          middleware: [checkAuthenticationPage],
        },
      },
      {
        path: 'cambiar-contrasena/:recovery_session',
        name: 'Recovery Reset',
        component: () => import(/* webpackChunkName: "recovery-reset" */ '../views/auth/recovery/Reset.vue'),
        meta: {
          title: 'Reiniciar contraseña',
          middleware: [checkAuthenticationPage],
        },
      },
      {
        path: 'curso/:course_id/enrollment/gratis',
        name: 'Enroll',
        component: () => import(/* webpackChunkName: "enroll" */ '../views/Enroll.vue'),
        meta: {
          title: 'Verificar inscripción',
          middleware: [checkAuthenticatedUser],
        },
      },
      {
        path: 'certificados/:certification_id',
        name: 'Certificate',
        component: () => import(/* webpackChunkName: "certificate" */ '../views/Certificate.vue'),
        meta: {
          title: 'Certificado',
          middleware: [enableFreePass],
        },
      },
      {
        path: '*',
        name: 'Error',
        component: () => import(/* webpackChunkName: "error-404" */ '../views/404.vue'),
        meta: {
          title: 'Contenido no encontrado',
          middleware: [enableFreePass],
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.onError((error) => {
  const targetPath = router.history.pending.fullPath;

  history.replaceState("", "", '/panel' + targetPath);

  window.location.reload()
});

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];

  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);

    const nextMiddleware = nextFactory(context, middleware, index + 1);

    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };

    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = (to.meta.title) ? `${to.meta.title} - Arcux` : 'Arcux';
  });
})

export default router;
